<template>
  <MainAsideRightHead
    :title="(user && user.id ? 'Редактирование' : 'Добавление') + ' пользователей'"
    store-path="users"
    :can-save="canSave"
    :options-visible="false"
    :save-text="user && user.id ? 'Сохранить' : 'Добавить'"
    @save="save"
  ></MainAsideRightHead>
</template>

<script>
import MainAsideRightHead from '@/components/MainAsideRight/MainAsideRightHead';
import { mapState } from 'vuex';

export default {
  components: { MainAsideRightHead },
  computed: {
    ...mapState('users', {
      user: s => s.aside.data.user,
      canSave: s => s.aside.meta.canSave
    })
  },
  methods: {
    async save() {
      if (!this.canSave) {
        return;
      }

      let status;

      if (this.user && this.user.id) {
        status = await this.$store.dispatch('users/editUser');
      } else {
        status = await this.$store.dispatch('users/addUser');
      }

      if (status === 'success') {
        this.closeAside();
      }
    },
    closeAside() {
      this.$store.dispatch('users/setAsideMeta', {
        path: 'forceClose',
        value: true
      });
    }
  }
};
</script>
